import React, { useState, useEffect } from "react"
import { Paper, Grid } from "@material-ui/core"
import {
  InputCheckboxMaster,
  InputOptionMaster,
  InputReactDatepicker,
  InputTextArea,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui"

import {
  RESET_STATE_BOOKING_ANTRIAN,
  STYLE_MASTER_GUDANG_UTAMA,
  validation,
  urlAddBookingAntrian,
  dayToInt,
  DoctorAndScheduleForm,
  KODE_JKN,
  urlGetStatusJKN,
  KODE_ONSIDE,
} from "."
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
  DEFAULT_BOX_SHADOW,
  BASE_URL_2,
  instanceWsBPJS,
} from "App/constants"

import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
  toUTCFormat,
  nl2br,
} from "App/utils/helpers"

import { SearchIcon, SelectIcon } from "App/Assets"
import { useScehuldeDokter } from "."
import { getDay } from "date-fns"
import { ModalKunjunganBaru } from "../../KunjunganRawatJalan/ui"
import { getToken } from "App/utils/cookies"
import { useSelector } from "react-redux"
import { KODE_PRINTER_SETTING, messageError, URL_SETTING } from "utils/all"
import ModalCancelBookingJKN from "./ModalCancelBookingJKN"
import ModalDetailJkn from "./ModalDetailJkn"
import ModalTableListMultiNoRujukanRawatJalan from "../../KunjunganRawatJalan/ui/TableListMultiNoRujukan/TableListMultiNoRujukanRawatJalan"
import TableListNoRencanaKontrol from "../../KunjunganRawatJalan/ui/TableListRencanaKontrol/TableListNoRencanaKontrol"
import ModalCancelBooking from "App/Component/layout/VerifikasiBooking/ui/ModalCancelBooking"

export default function FormBookingAntrian({
  formData,
  setFormData,
  setNewData,
}) {
  const classes = STYLE_MASTER_GUDANG_UTAMA()
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)
  const [showModalCancel, setShowModalCancel] = useState(false)
  const [showModalDetailJKN, setShowModalDetailJKN] = useState(false)
  const [loadingJKN, setLoadingJKN] = useState(false)
  const [showModalRm, setShowModalRm] = useState(false)
  const [onlyDisplayDay, setOnlyDisplayDay] = useState(5)
  const [dataJKN, setDataJKN] = useState()
  const [showModalMultiNoRujukan, setShowModalMultiNoRujukan] = useState(false)
  const [showModalCancelOnsite, setShowModalCancelOnsite] = useState(false)
  const [showModalRencanaKontrol, setShowModalRencanaKontrol] = useState(false)
  const [rowsRencanaKontrol, setRowsRencanaKontrol] = useState([])
  const [rowsRencanaKontrolUtama, setRowsRencanaKontrolUtama] = useState([])
  const add = async () => {
    const scheduleIdAndDay = formData.schedule_doctor_id.split("--")
    return instance2.post(urlAddBookingAntrian, {
      date: toUTCFormat(formData.date),
      rm_id: formData.rm_id,
      nik: formData.nik,

      name: formData.name,
      schedule_doctor_id: scheduleIdAndDay[0],

      mobile_phone: formData.mobile_phone,
      company_id: formData.company_id,
      insurance_id: formData.insurance_id,
      insurance_no: formData.insurance_no,

      norujukan: formData.norujukan,
      nokontrol: formData.nokontrol,
      remark: nl2br(formData.remark),
      pasien_prioritas: formData.pasien_prioritas,
    })
  }

  const fetchStatusJkn = async () => {
    const kode_booking =
      typeof formData.id === "number" ? formData.id.toString() : null
    return instanceWsBPJS.post(urlGetStatusJKN, {
      kode_booking,
    })
  }

  const scheduleDokter = useScehuldeDokter(formData.doctor_id)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    try {
      const valid = validation(formData)
      if (valid.state) {
        const response = await add()
        defaultToastSuccess("Berhasil menambah Booking Antrian")
        const scheduleDokterFilter = scheduleDokter.filter(
          (item) => item.value === formData.schedule_doctor_id,
        )

        setFormData({
          ...formData,
          id: response.data.antrian.booking_id,
          initial: response.data.antrian.initial,
          antrianno: response.data.antrian.antrianno,
          doctor_schedule_day: formData.schedule_doctor_id.split("--")[1],
          doctor_schedule_time_start:
            scheduleDokterFilter[0].label.split(" ")[1],
          doctor_schedule_time_finish:
            scheduleDokterFilter[0].label.split(" ")[3],
          poli_name: response.data.antrian?.nama_poliklinik,
        })
        setNewData()
      } else {
        defaultToastError(valid.message)
      }
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError(error?.response?.data?.message)
    }
  }

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    })
  }

  const { setting, master } = useSelector((state) => state)
  const printerEnv = setting.printer_env

  useEffect(() => {
    if (formData.schedule_doctor_id !== "") {
      const idAndDay = formData.schedule_doctor_id.split("--")
      setOnlyDisplayDay(dayToInt(idAndDay[1]))
    }
  }, [formData.schedule_doctor_id])

  const isWeekday = (date) => {
    const day = getDay(date)
    return day === onlyDisplayDay
  }

  const handleClickSelect = (row) => {
    setFormData({
      ...formData,
      rm_id: row?.id,
      name: row?.fullname,
      mobile_phone: row?.mobile_phone_number,

      insurance_id: row?.insurance_id,
      insurance_name: row?.insurance_name,

      insurance_no: row?.insurance_number,
      company_id: row?.company_id,
      company_name: row?.company_name,

      nik: row?.nik,
      label_rm: row?.id,
    })
    setShowModalRm(false)
  }

  const handleClickPrint = () => {
    const url = `${BASE_URL_2}/registration/registration/getbooking-byid/${formData.id}`
    window.open(
      `http://localhost/${
        process.env.REACT_APP_PRINT_NAME
      }/public/api/print-booking-antrian?url=${url}&nama_rumah_sakit=${
        printerEnv.nama_rumah_sakit
      }&id_booking=${
        formData.id
      }&token=${getToken()}&url_setting=${URL_SETTING}&kode_setting=${
        KODE_PRINTER_SETTING.printer_antrian_booking
      }`,
      "MsgWindow",
    )
  }

  const handleClickStatusJKN = async () => {
    setShowModalDetailJKN(true)
    setDataJKN()
    try {
      setLoadingJKN(true)
      const response = await fetchStatusJkn()
      const data = response.data?.response?.list
      setDataJKN(data)
    } catch (error) {
      defaultToastError("Terjadi Kesalahan saat mengambil data JKN")
      console.log("GAGAL MENDAPATKAN DATA JKN: ", error)
    } finally {
      setLoadingJKN(false)
    }
  }

  return (
    <Paper className={classes.paper}>
      {showModalRencanaKontrol && (
        <TableListNoRencanaKontrol
          setShowModal={() => setShowModalRencanaKontrol(false)}
          formData={formData}
          setFormData={setFormData}
          rows={rowsRencanaKontrol}
          setRows={setRowsRencanaKontrol}
          rowsUtama={rowsRencanaKontrolUtama}
          setRowsUtama={setRowsRencanaKontrolUtama}
        />
      )}

      {showModalCancelOnsite && (
        <ModalCancelBooking
          setFormData={setFormData}
          formData={formData}
          setShowModalCancel={setShowModalCancelOnsite}
          setNewData={setNewData}
          setShowModal={() => setShowModalCancelOnsite(false)}
        />
      )}

      {showModalMultiNoRujukan && (
        <ModalTableListMultiNoRujukanRawatJalan
          setShowModal={() => setShowModalMultiNoRujukan(false)}
          noKartu={formData.insurance_no}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalCancel && (
        <ModalCancelBookingJKN
          setFormData={setFormData}
          formData={formData}
          setShowModalCancel={setShowModalCancel}
          setNewData={setNewData}
          setShowModal={() => setShowModalCancel(false)}
        />
      )}
      {showModalDetailJKN && (
        <ModalDetailJkn
          setShowModal={setShowModalDetailJKN}
          formData={formData}
          dataJKN={dataJKN}
          loadingJKN={loadingJKN}
          setFormData={setFormData}
        />
      )}
      {showModalRm && (
        <ModalKunjunganBaru
          setFormData={setFormData}
          formData={formData}
          title="Cari Rekam Medis"
          onlyInternal={true}
          setShowModal={() => setShowModalRm(false)}
          handleClickSelect={handleClickSelect}
        />
      )}

      {formData?.status_rm === "kosong" && (
        <InfoCard title="Harap mapping profile rekam medis terlebih dahulu" />
      )}
      {formData?.status_rm === false && (
        <InfoCard title="Harap lengkapi profile rekam medis terlebih dahulu" />
      )}

      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={3}>
            <InputTextMaster
              name="rm_id"
              label="PILIH RM"
              id="rm_id"
              disabled={true}
              placeholder={formData.label_rm}
              error={true}
              message={messageError.required}
              withButton={isNull(formData.id) ? true : false}
            >
              <button
                type={"button"}
                onClick={() => setShowModalRm(!showModalRm)}
                style={{
                  borderRight: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderLeft: "0",
                  background: "#fff",
                  padding: "0 0.8rem",
                  cursor: "pointer",
                  borderRadius: "0 6px 6px 0",
                }}
              >
                <SearchIcon width={"12"} height={"12"} fill={"#333"} />
              </button>
            </InputTextMaster>
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="name"
              label="NAMA"
              id="name"
              placeholder="Nama"
              disabled={true}
              readOnly={true}
              value={formData.name}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="mobile_phone"
              label="TELEPON"
              id="mobile_phone"
              placeholder="No Telepon"
              value={formData.mobile_phone}
              onChange={handleChange("mobile_phone")}
              disabled={!isNull(formData.id) ? true : false}
              readOnly={!isNull(formData.id) ? true : false}
              error={true}
              message={messageError.required}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="nik"
              label="NIK"
              id="nik"
              placeholder="NIK"
              value={formData.nik}
              disabled={true}
              readOnly={true}
              error={true}
              message={"Jika kosong, silahkan cek profile rekam medis"}
            />
          </Grid>
        </Grid>

        <p className="fw-600 mt-2 fs-12">ASURANSI</p>
        <div className="mt-05">
          <Grid container spacing={2}>
            <Grid item sm={4}>
              <InputOptionMaster
                name="insurance_id"
                label="ASURANSI"
                id="insurance_id"
                withSearch={true}
                data={master.asuransi.list_select}
                value={formData.insurance_id}
                disabled={!isNull(formData.id) ? true : false}
                readOnly={!isNull(formData.id) ? true : false}
                labelValue={formData.insurance_name}
                error={true}
                message={messageError.required}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      insurance_id: null,
                      insurance_name: "Pilih Asuransi",
                    })
                  } else {
                    setFormData({
                      ...formData,
                      insurance_id: e.value,
                      insurance_name: e.label,
                    })
                  }
                }}
              />
            </Grid>
            <Grid item sm={4}>
              <InputOptionMaster
                name="company_id"
                label="PERUSAHAAN"
                id="company_id"
                withSearch={true}
                data={master.perusahaan.list_select}
                value={formData.company_id}
                labelValue={formData.company_name}
                error={true}
                message={"Wajib Diisi - Jika umum pilih UMUM"}
                disabled={!isNull(formData.id) ? true : false}
                readOnly={!isNull(formData.id) ? true : false}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormData({
                      ...formData,
                      company_id: null,
                      company_name: "Pilih Perusahaan",
                    })
                  } else {
                    setFormData({
                      ...formData,
                      company_id: e.value,
                      company_name: e.label,
                    })
                  }
                }}
              />
            </Grid>
            <Grid item sm={4}>
              <InputTextMaster
                name="insurance_no"
                label="NO ASURANSI"
                id="insurance_no"
                placeholder="No Asuransi"
                value={formData.insurance_no}
                disabled={!isNull(formData.id) ? true : false}
                readOnly={!isNull(formData.id) ? true : false}
                onChange={handleChange("insurance_no")}
                error={true}
                message={"Selain umum, wajib diisi"}
              />
            </Grid>
            <Grid item sm={4}>
              <div style={{ display: "flex" }}>
                <InputTextMaster
                  name="norujukan"
                  label="NO RUJUKAN"
                  id="norujukan"
                  placeholder="No Rujukan"
                  value={formData.norujukan}
                  onChange={handleChange("norujukan")}
                  disabled={!isNull(formData.id) ? true : false}
                  readOnly={!isNull(formData.id) ? true : false}
                  error={true}
                  message={"Jika BPJS, wajib diisi"}
                />
                <MasterButton
                  type={"button"}
                  color="lightgreen"
                  name=""
                  size="sm"
                  withIcon={true}
                  onClick={() => {
                    setShowModalMultiNoRujukan(!showModalMultiNoRujukan)
                  }}
                  style={{
                    marginTop: "1.5rem",
                    width: "32px",
                    height: "32px",
                  }}
                  icon={
                    <SelectIcon
                      width="16px"
                      height="16px"
                      style={{
                        marginLeft: "-0.5rem",
                      }}
                    />
                  }
                />
              </div>
            </Grid>
            <Grid item sm={4}>
              <div style={{ display: "flex" }}>
                <InputTextMaster
                  name="nokontrol"
                  label="NO KONTROL"
                  id="nokontrol"
                  placeholder="No Kontrol"
                  value={formData.nokontrol}
                  onChange={handleChange("nokontrol")}
                  disabled={!isNull(formData.id) ? true : false}
                  readOnly={!isNull(formData.id) ? true : false}
                />
                <MasterButton
                  type={"button"}
                  color="lightgreen"
                  name=""
                  size="sm"
                  withIcon={true}
                  onClick={() =>
                    setShowModalRencanaKontrol(!showModalRencanaKontrol)
                  }
                  style={{
                    marginTop: "1.5rem",
                    width: "32px",
                    height: "32px",
                  }}
                  icon={
                    <SelectIcon
                      width="16px"
                      height="16px"
                      style={{
                        marginLeft: "-0.5rem",
                      }}
                    />
                  }
                />
              </div>
            </Grid>
          </Grid>
        </div>

        <p className="fw-600 mt-2 fs-12">JADWAL BOOKING</p>
        <div className="mt-05">
          <Grid container>
            <Grid item sm={8}>
              <Grid container spacing={1}>
                <DoctorAndScheduleForm
                  // handleChange={handleChangeAsuransi}
                  handleChange={handleChange}
                  setFormData={setFormData}
                  formData={formData}
                  dokter={master.dokter.list_select}
                  scheduleDokter={scheduleDokter}
                />
                <Grid item sm={4}>
                  <InputReactDatepicker
                    id="date"
                    label="Tanggal"
                    selected={formData.date}
                    autoComplete="off"
                    disabled={formData.schedule_doctor_id === "" ? true : false}
                    dateFormat={"dd/MM/yyyy"}
                    onChange={(date) => {
                      setFormData({
                        ...formData,
                        date: date,
                      })
                    }}
                    minDate={new Date()}
                    filterDate={isWeekday}
                    placeholderText="Tanggal"
                    error={true}
                    message="Wajib Diisi"
                  />
                </Grid>

                <Grid item sm={12}>
                  <InputTextArea
                    label={"KETERANGAN"}
                    placeholder={"Keterangan"}
                    name="remark"
                    value={formData.remark}
                    onChange={handleChange("remark")}
                    id="remark"
                    rows={"3"}
                  />
                </Grid>
                <Grid item sm={4}>
                  <InputCheckboxMaster
                    checked={formData.pasien_prioritas}
                    name="pasien_prioritas"
                    id="pasien_prioritas"
                    label="PASIEN PRIORITAS"
                    onChange={() =>
                      setFormData({
                        ...formData,
                        pasien_prioritas: !formData.pasien_prioritas,
                      })
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={4}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: "1rem",
                    marginTop: "-7rem",
                  }}
                >
                  {formData.initial !== "" && formData.antrianno !== "" && (
                    <div
                      style={{
                        backgroundColor: "#fff",
                        boxShadow: DEFAULT_BOX_SHADOW,
                        marginLeft: "0.6rem",
                        marginTop: "3rem",
                        borderRadius: "12px",
                        padding: "2rem 3rem 3rem 2rem",
                        textAlign: "center",
                      }}
                    >
                      <p>No Antrian </p>
                      <div
                        style={{
                          display: "flex",
                          color: "#296218",
                          fontSize: "70px",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "600",
                        }}
                      >
                        {formData.initial}-{formData.antrianno}
                      </div>
                    </div>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>

        <div className="mt-2">
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <MasterButton
              className={"mt-1"}
              type="button"
              color="danger"
              name="Reset"
              onClick={() => {
                setFormData(RESET_STATE_BOOKING_ANTRIAN)
              }}
              size="md"
            />

            <div
              style={{
                display: "flex",
                gap: "20px",
              }}
            >
              {!isNull(formData.id) && (
                <>
                  <MasterButton
                    className={"mt-1"}
                    type="button"
                    color="green"
                    name="CETAK ANTRIAN"
                    outline={true}
                    size="md"
                    onClick={handleClickPrint}
                  />
                  <MasterButton
                    type={"button"}
                    className={"mt-1"}
                    color={"warning"}
                    name={"STATUS JKN"}
                    outline
                    onClick={(e) => handleClickStatusJKN(e)}
                    size="md"
                  />
                </>
              )}

              {!isNull(formData.id) && formData.asal === KODE_JKN ? (
                <>
                  <MasterButton
                    type={"button"}
                    className={"mt-1"}
                    disabled={formData.status_booking === true ? false : true}
                    color={
                      formData.status_booking === true ? "danger" : "secondary"
                    }
                    name={
                      formData.status_booking === true
                        ? "BATAL BOOKING"
                        : "BOOKING JKN DIBATALKAN"
                    }
                    onClick={() => setShowModalCancel(true)}
                    size="md"
                  />
                </>
              ) : (
                <></>
              )}
              {!isNull(formData.id) && formData.asal === KODE_ONSIDE ? (
                <>
                  <MasterButton
                    type={"button"}
                    className={"mt-1"}
                    disabled={formData.status_booking === true ? false : true}
                    color={
                      formData.status_booking === true ? "danger" : "secondary"
                    }
                    name={
                      formData.status_booking === true
                        ? "BATAL BOOKING"
                        : "BOOKING ONSITE DIBATALKAN"
                    }
                    onClick={() => setShowModalCancelOnsite(true)}
                    size="md"
                  />
                </>
              ) : (
                <></>
              )}
              {isNull(formData.id) && (
                <MasterButton
                  className={"mt-1"}
                  type="submit"
                  color={disabled.color}
                  name={disabled.label}
                  disabled={disabled.state}
                  size="md"
                />
              )}
            </div>
          </Grid>
        </div>
      </form>
    </Paper>
  )
}

const InfoCard = ({ title }) => {
  return (
    <div
      style={{
        background: "#F09F00",
        width: "100%",
        padding: "12px 8px",
        color: "white",
        fontSize: "12px",
        borderRadius: "6px",
      }}
    >
      {title}
    </div>
  )
}
